import { Grid, Menu, ListItemText, ListItemIcon, Typography, Box, FormControlLabel, Switch, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowDropDown, CloudDownload, Done, PlaylistAddCheck } from '@material-ui/icons';
import { Button, ConfirmationMenuItem, ConfirmDialog, DateField, SelectField, Toolbar } from '@roc/ui';
import { observer } from 'mobx-react';
import { useRef, useState } from 'react';
import { useServicingTransfersStore } from "../../hooks/useServicingTransfersStore";
import { ToolbarInfoItem } from '@roc/feature-special-servicing';
import { ServicingTransferTabs } from '../../utils/constants';
import { MarkAsBoardedModal } from './markAsBoardedModal';

const useStyles = makeStyles(theme => ({
  buttonContainer: {
    display: 'flex',
    gap: '10px'
  },
  selectorFilterContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  selectorFilter: {
    width: '180px',
    marginRight: '16px',
  },
  containerBox: {
    display: 'flex',
  },
  infoItemsBox: {
    marginRight: '40px',
    marginLeft: '25px',
    display: 'flex',
    alignItems: 'center',
    gap: '30px'
  },
}));

export const ServicingTransfersToolbar = observer(() => {
  const classes = useStyles();
  const { servicingTransfersStore } = useServicingTransfersStore();
  const { loanIds, showSelectedRecords, tab } = servicingTransfersStore;
  const anchorRef = useRef(null);
  const [showBulkActionsMenu, setShowBulkActionsMenu] = useState(false);
  const [showMarkAsBoardedModal, setShowMarkAsBoardedModal] = useState(false);

  const closeMenu = () => {
    setShowBulkActionsMenu(false);
  };

  const closeBoardedModal = () => {
    setShowMarkAsBoardedModal(false);
  }

  const setFromDate = (date) => {
    servicingTransfersStore.setDateFilters(date, servicingTransfersStore.toDate);
  }

  const setToDate = (date) => {
    servicingTransfersStore.setDateFilters(servicingTransfersStore.fromDate, date);
  }

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Toolbar
            left={
              <Grid className={classes.selectorFilterContainer}>
                <Typography style={{ paddingRight: '16px' }}>Filter: </Typography>
                <DateField
                  testId="fromDate"
                  inputVariant="outlined"
                  format="MM/dd/yyyy"
                  label="From"
                  value={servicingTransfersStore.fromDate}
                  onChange={date => setFromDate(date)}
                  maxDate={new Date()}
                  className={classes.selectorFilter}
                />
                <DateField
                  testId="toDate"
                  inputVariant="outlined"
                  format="MM/dd/yyyy"
                  label="To"
                  value={servicingTransfersStore.toDate}
                  onChange={date => setToDate(date)}
                  maxDate={new Date()}
                  className={classes.selectorFilter}
                />
              </Grid>
            }>
            <Box className={classes.containerBox}>
              {tab === ServicingTransferTabs.SERVICING_TRANSFER && (
                <>
                  <Box className={classes.infoItemsBox}>
                    <ToolbarInfoItem
                      value={loanIds.length}
                      label={'Count'}
                    />
                  </Box>
                  <Box style={{ textAlign: 'center', marginRight: '25px' }}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={showSelectedRecords}
                          onChange={() => {
                            servicingTransfersStore.setShowSelectedRecords(!showSelectedRecords);
                            servicingTransfersStore.servicingTransfersGridStore.resetAndFetchGridData();
                          }}
                          color="primary"
                        />
                      }
                      label="Show Selected"
                    />
                  </Box>
                  <Box style={{ textAlign: 'center' }}>
                    <div ref={anchorRef} style={{ display: 'inline-block' }}>
                      <Button
                        onClick={() => { setShowBulkActionsMenu(true) }}
                        testId="open_menu"
                        variant="contained"
                        size="small"
                        color="primary"
                        disabled={loanIds.length === 0}
                      >
                        Bulk Actions <ArrowDropDown style={{ marginRight: '-6px' }} />
                      </Button>
                      <Menu
                        id="basic-menu"
                        anchorEl={anchorRef.current}
                        open={showBulkActionsMenu}
                        onClose={closeMenu}
                        keepMounted={true}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'right',
                        }}
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                        }}
                        getContentAnchorEl={null}
                      >
                        <MenuItem
                          onClick={() => {
                            setShowMarkAsBoardedModal(true);
                            closeMenu();
                          }}
                        >
                          <ListItemIcon>
                            <Done fontSize="small" />
                          </ListItemIcon>
                          <ListItemText>Mark as Boarding Package Sent</ListItemText>
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            servicingTransfersStore.downloadServicingTransferReport(loanIds);
                            closeMenu();
                          }}
                        >
                          <ListItemIcon>
                            <CloudDownload fontSize="small" />
                          </ListItemIcon>
                          <ListItemText>Download Servicing Transfer Report</ListItemText>
                        </MenuItem>
                      </Menu>
                    </div>
                  </Box>
                </>
              )}
              {tab === ServicingTransferTabs.BOARDED && (
                <Box style={{ textAlign: 'center' }}>
                  <div ref={anchorRef} style={{ display: 'inline-block' }}>
                    <Button
                      onClick={() => { servicingTransfersStore.exportHistoricBoardedServicingTransfers(); }}
                      testId="open_menu"
                      variant="contained"
                      size="small"
                      color="primary"
                    >
                      Export as Excel
                    </Button>
                  </div>
                </Box>
              )}
            </Box>
          </Toolbar>
        </Grid>
      </Grid>
      <MarkAsBoardedModal
        servicingTransfersStore={servicingTransfersStore}
        showMarkAsBoardedModal={showMarkAsBoardedModal}
        closeBoardedModal={closeBoardedModal}
        loanIds={loanIds}
      />
    </>
  );
});